import React, { useState } from "react";
import { Modal, ModalBody, ModalHeader, Col, Row, Button } from "reactstrap";
//redux
import { connect } from "react-redux";
// alerta
import SweetAlert from "react-bootstrap-sweetalert";
// select
import Select from "react-select";
// query
import { useMutation } from "react-query";
//services
import { createFlight } from "../../../utils/services/flight";
import ButtonSpinner from "../../../components/Buttons/ButtonSpinner";

function NewFlight(props) {
  const { isOpen, toggle, user } = props;
  const [modalBackdrop, setModalBackdrop] = useState(false);
  const [participantSelected, setParticipantSelected] = useState(
    user?.id ? user.id : null
  );
  //confirmção de criação
  const [success_dlg, setsuccess_dlg] = useState(false);
  //state dos campos obrigatórios
  const [participantError, setParticipantError] = useState("");
  const [companyError, setCompanyError] = useState("");
  const [sourcerError, setSourceError] = useState("");
  const [destinyError, setDestinyError] = useState("");
  const [dateBoardingError, setDateBoardingError] = useState("");
  const [timeBoardingError, setTimeBoardingError] = useState("");
  const [dateArrivalError, setDateArrivalError] = useState("");
  const [timeArrivalError, setTimeArrivalError] = useState("");
  const [isLoading, setIsloading] = useState(false);

  const [dateBoarding, setDateBoarding] = useState("");

  function toggleBackdrop() {
    setModalBackdrop(!modalBackdrop);
  }
  function checkDateTimeInterval(e) {
    const isValidDate = (d) => d && d !== "";
    const isValidTime = (t) => t && t !== "";

    const dateStart = e.target[1].value;
    const dateEnd = e.target[3].value;
    const hourStart = e.target[2].value;
    const hourEnd = e.target[4].value;

    const hasStartDate = isValidDate(dateStart);
    const hasEndDate = isValidDate(dateEnd);
    const hasStartHour = isValidTime(hourStart);
    const hasEndHour = isValidTime(hourEnd);

    const startDateTime =
      hasStartDate && hasStartHour
        ? new Date(`${dateStart}T${hourStart}`)
        : null;

    const endDateTime =
      hasEndDate && hasEndHour ? new Date(`${dateEnd}T${hourEnd}`) : null;

    if (startDateTime && endDateTime && endDateTime >= startDateTime) {
      return true;
    }

    return false;
  }
  const clearErrors = () => {
    setDateBoardingError("");
    setTimeBoardingError("");
    setDateArrivalError("");
    setTimeArrivalError("");
    setDateArrivalError("");
    setCompanyError("");
    setSourceError("");
    setDestinyError("");
  };

  async function submitForm(e) {
    clearErrors();

    if (
      !user &&
      (!participantSelected || participantSelected === "Selecione")
    ) {
      setParticipantError("O campo Participante é obrigatório");
      return;
    } else setParticipantError("");

    if (e.target[1].value === "") {
      setDateBoardingError("O campo Data embarque é obrigatório");
      return;
    } else setDateBoardingError("");

    if (e.target[2].value === "") {
      setTimeBoardingError("O campo Hora embarque é obrigatório");
      return;
    } else setTimeBoardingError("");

    if (e.target[3].value === "") {
      setDateArrivalError("O campo Data chegada é obrigatório");
      return;
    } else setDateArrivalError("");

    if (e.target[4].value === "") {
      setTimeArrivalError("O campo Hora chegada é obrigatório");
      return;
    } else setTimeArrivalError("");

    if (!checkDateTimeInterval(e)) {
      setDateArrivalError(
        "A Data e Hora chegada não pode ser menor que a Data e Hora embarque."
      );
      return;
    } else setDateArrivalError("");

    if (e.target[5].value === "") {
      setCompanyError("O campo Companhia é obrigatório");
      return;
    } else setCompanyError("");

    if (e.target[6].value === "") {
      setSourceError("O campo Origem é obrigatório");
      return;
    } else setSourceError("");

    if (e.target[7].value === "") {
      setDestinyError("O campo Destino é obrigatório");
      return;
    } else setDestinyError("");

    setIsloading(true);

    await createFlight({
      event: props.idEvent,
      login: participantSelected,
      boardingdate: e.target[1].value,
      boardingtill: e.target[2].value,
      arrivaldate: e.target[3].value,
      arrivaltime: e.target[4].value,
      company: e.target[5].value,
      origin: e.target[6].value,
      destination: e.target[7].value,
      locator: e.target[8].value,
      eticket: e.target[9].value,
      flightnumber: e.target[10].value,
      terminal: e.target[11].value,
      seat: e.target[12].value,
      boardinggroup: e.target[13].value,
      extrainformation: e.target[14].value,
      jwt: props.state.global_user_data.data.token,
    })
      .then((res) => {
        setIsloading(false);
        const { message } = res;

        if (message === "created") {
          // atualizar tabela
          props.data();
          setsuccess_dlg(true);
        }
      })
      .catch((error) => {
        console.log("erro", error);
        setIsloading(false);
      });
  }

  return (
    <Modal
      isOpen={isOpen}
      toggle={() => {
        toggleBackdrop();
      }}
      autoFocus={true}
      centered={true}
    >
      {success_dlg ? (
        <SweetAlert
          success
          title={"Criado"}
          onConfirm={() => {
            toggle();
            setsuccess_dlg(false);
          }}
        >
          {"Voo criado com sucesso!"}
        </SweetAlert>
      ) : null}
      <ModalHeader toggle={toggle}>Novo Voo</ModalHeader>
      <ModalBody>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            submitForm(e);
          }}
        >
          <Row>
            <Col lg={12}>
              <Select
                placeholder={"Selecione um participantes..."}
                isLoading={props.participants?.length > 0 ? false : true}
                loadingMessage={() => "Carregando..."}
                noOptionsMessage={() => "Nenhum participante encontrado"}
                defaultValue={
                  user
                    ? {
                        label: user.nome,
                        value: user.id,
                      }
                    : {}
                }
                isDisabled={user}
                onChange={(e) => {
                  setParticipantSelected(e.value);
                }}
                options={[
                  {
                    options: props.participants
                      ? [
                          ...props?.participants?.map((e) => {
                            return { label: e.nome, value: e.id };
                          }),
                        ]
                      : [],
                  },
                ]}
                classNamePrefix="select2-selection"
                menuPortalTarget={document.body}
                styles={{
                  menuPortal: (base) => ({
                    ...base,
                    zIndex: 9999,
                  }),
                  menu: (provided) => ({
                    ...provided,
                    maxHeight: 150,
                  }),
                  menuList: (provided) => ({
                    ...provided,
                    maxHeight: 150,
                    overflowY: "auto",
                  }),
                }}
              />
              {participantError && (
                <a style={{ color: "red" }}>{participantError}</a>
              )}
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            <Col lg={6}>
              <div>
                <label className="form-label">Data embarque*</label>
                <input
                  className="form-control"
                  type="date"
                  // defaultValue="2019-08-19T13:45:00"
                  id="example-datetime-local-input"
                  onChange={({ target }) => setDateBoarding(target.value)}
                />
              </div>
              {dateBoardingError && (
                <a style={{ color: "red" }}>{dateBoardingError}</a>
              )}
            </Col>

            <Col lg={6}>
              <div>
                <label className="form-label">Hora embarque*</label>
                <input
                  className="form-control"
                  type="time"
                  id="example-datetime-local-input"
                />
              </div>
              {timeBoardingError && (
                <a style={{ color: "red" }}>{timeBoardingError}</a>
              )}
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            <Col lg={6}>
              <div>
                <label className="form-label">Data chegada*</label>
                <input
                  className="form-control"
                  type="date"
                  id="example-datetime-local-input"
                  min={dateBoarding || ""}
                />
                {dateArrivalError && (
                  <a style={{ color: "red" }}>{dateArrivalError}</a>
                )}
              </div>
            </Col>

            <Col lg={6}>
              <div>
                <label className="form-label">Hora chegada*</label>
                <input
                  className="form-control"
                  type="time"
                  // defaultValue="2019-08-19T13:45:00"
                  id="example-datetime-local-input"
                />
                {timeArrivalError && (
                  <a style={{ color: "red" }}>{timeArrivalError}</a>
                )}
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Companhia*</label>
                <input className="form-control" type="text" />
              </div>
              {companyError && <a style={{ color: "red" }}>{companyError}</a>}
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Origem*</label>
                <input className="form-control" type="text" />
              </div>
              {sourcerError && <a style={{ color: "red" }}>{sourcerError}</a>}
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Destino*</label>
                <input className="form-control" type="text" />
              </div>
              {destinyError && <a style={{ color: "red" }}>{destinyError}</a>}
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Localizador</label>
                <input className="form-control" type="text" />
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">E-Ticket</label>
                <input className="form-control" type="text" />
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Número do Voo</label>
                <input className="form-control" type="text" />
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Terminal</label>
                <input className="form-control" type="text" />
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Assento</label>
                <input className="form-control" type="text" />
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Grupo de embarque</label>
                <input className="form-control" type="text" />
              </div>
            </Col>
          </Row>

          <Row style={{ marginTop: 20 }}>
            <Col lg={12}>
              <div>
                <label className="form-label">Informações extras</label>
                <input className="form-control" type="text" />
              </div>
            </Col>
          </Row>

          <Row
            style={{
              width: "100%",
              margin: "20px auto 0",
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            <Button
              color="danger"
              className="btn waves-effect waves-light"
              style={{ width: 80, marginRight: 15 }}
              onClick={() => toggle()}
            >
              Fechar
            </Button>
            <ButtonSpinner isLoading={isLoading} title={"Salvar"} />
          </Row>
        </form>
      </ModalBody>
    </Modal>
  );
}

const mapStateToProps = function (state) {
  return { state: state };
};

export default connect(mapStateToProps)(NewFlight);
